// Mounts once near the app root. Triggers `useCountry()` so the geo edge function
// runs early and populates sessionStorage for `mobileMoney.ts` to read.
import { useCountry } from "@/hooks/useCountry";

export function GeoBootstrap() {
  useCountry();
  return null;
}
